import { useLang } from "@/context/LanguageContext";

const COLORS = { calories: "#C87D65", protein: "#C87D65", carbs: "#A8BBA2", fat: "#E8B4B8" };

export function DayTargets({ day, memberId }) {
  const { t } = useLang();
  const planned = day?.totals_by_member?.[memberId] || day?.totals;
  const target = day?.targets_by_member?.[memberId];
  if (!planned) return null;

  return (
    <div className="chenia-card p-4 sm:p-5" data-testid="plan-day-totals">
      <div className="flex items-center justify-between text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-3">
        <span>{t("planned")} / {t("target")}</span>
        <span>{t(day.day)}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {["calories", "protein", "carbs", "fat"].map((k) => {
          const v = planned[k] ?? 0;
          const tg = target?.[k];
          const pct = tg ? Math.min(100, Math.round((v / tg) * 100)) : 0;
          const unit = k === "calories" ? t("kcal") : "g";
          return (
            <div key={k} data-testid={`day-target-${k}`}>
              <div className="flex items-baseline justify-between">
                <p className="font-serif text-xl font-semibold">{v}<span className="text-xs text-muted-foreground ml-0.5">{unit}</span></p>
                {tg && <p className="text-xs text-muted-foreground">/ {tg}</p>}
              </div>
              <div className="h-1.5 rounded-full bg-secondary mt-1.5 overflow-hidden">
                <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${pct}%`, backgroundColor: COLORS[k] }} />
              </div>
              <p className="text-[11px] text-muted-foreground mt-1">{t(k)}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
